/**
 * ┌─────────────────────────────────────────────────────────────────────────┐
 * │  THE SINGLE TOUCH-POINT.                                                   │
 * │  APP_ID must match the row seeded in accounts (apps-seed) — here 'games'  │
 * │  (:3300, games.owlcat.fartusov.com). Everything else (SSO login/return,  │
 * │  JIT users, the S2S service-token lookup, the accounts /login & /profile  │
 * │  deep-links) follows from it.                                             │
 * └─────────────────────────────────────────────────────────────────────────┘
 */
export const APP_ID = "games" as const;

/** Human-facing product name (metadata, header). Cosmetic — safe to change. */
export const APP_NAME = "OwlCat Games";
